'use strict';

var getMaybeFragmentData = require('./getMaybeFragmentData.js');

/**
 * Creates a fragment parser that extracts the fragment data and passes it to a callback.
 *
 * The resulting function will also accept an already extracted fragment data object
 *
 * @param fragment
 * @param callback
 * @returns
 */ const createFragmentParser = (fragment, callback)=>(maybeFragmentData)=>{
        const data = getMaybeFragmentData(fragment, maybeFragmentData);
        return callback(data);
    };

module.exports = createFragmentParser;
